module.exports = __webpack_public_path__ + "static/rate-my-bistro-login-438597b80ad85754b606d9730a35290e.png";